import { Vector3 } from "../Maths/math.vector";
/**
 * Holds the data for the raycast result
 * @see https://doc.babylonjs.com/how_to/using_the_physics_engine
 */
var PhysicsRaycastResult = /** @class */ (function () {
    function PhysicsRaycastResult() {
        this._hasHit = false;
        this._hitDistance = 0;
        this._hitNormalWorld = Vector3.Zero();
        this._hitPointWorld = Vector3.Zero();
        this._rayFromWorld = Vector3.Zero();
        this._rayToWorld = Vector3.Zero();
    }
    Object.defineProperty(PhysicsRaycastResult.prototype, "hasHit", {
        /**
         * Gets if there was a hit
         */
        get: function () {
            return this._hasHit;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PhysicsRaycastResult.prototype, "hitDistance", {
        /**
         * Gets the distance from the hit
         */
        get: function () {
            return this._hitDistance;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PhysicsRaycastResult.prototype, "hitNormalWorld", {
        /**
         * Gets the hit normal/direction in the world
         */
        get: function () {
            return this._hitNormalWorld;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PhysicsRaycastResult.prototype, "hitPointWorld", {
        /**
         * Gets the hit point in the world
         */
        get: function () {
            return this._hitPointWorld;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PhysicsRaycastResult.prototype, "rayFromWorld", {
        /**
         * Gets the ray "start point" of the ray in the world
         */
        get: function () {
            return this._rayFromWorld;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PhysicsRaycastResult.prototype, "rayToWorld", {
        /**
         * Gets the ray "end point" of the ray in the world
         */
        get: function () {
            return this._rayToWorld;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Sets the hit data (normal & point in world space)
     * @param hitNormalWorld defines the normal in world space
     * @param hitPointWorld defines the point in world space
     */
    PhysicsRaycastResult.prototype.setHitData = function (hitNormalWorld, hitPointWorld) {
        this._hasHit = true;
        this._hitNormalWorld = new Vector3(hitNormalWorld.x, hitNormalWorld.y, hitNormalWorld.z);
        this._hitPointWorld = new Vector3(hitPointWorld.x, hitPointWorld.y, hitPointWorld.z);
    };
    /**
     * Sets the distance from the start point to the hit point
     * @param distance
     */
    PhysicsRaycastResult.prototype.setHitDistance = function (distance) {
        this._hitDistance = distance;
    };
    /**
     * Calculates the distance manually
     */
    PhysicsRaycastResult.prototype.calculateHitDistance = function () {
        this._hitDistance = Vector3.Distance(this._rayFromWorld, this._hitPointWorld);
    };
    /**
     * Resets all the values to default
     * @param from The from point on world space
     * @param to The to point on world space
     */
    PhysicsRaycastResult.prototype.reset = function (from, to) {
        if (from === void 0) { from = Vector3.Zero(); }
        if (to === void 0) { to = Vector3.Zero(); }
        this._rayFromWorld = from;
        this._rayToWorld = to;
        this._hasHit = false;
        this._hitDistance = 0;
        this._hitNormalWorld = Vector3.Zero();
        this._hitPointWorld = Vector3.Zero();
    };
    return PhysicsRaycastResult;
}());
export { PhysicsRaycastResult };
//# sourceMappingURL=physicsRaycastResult.js.map